// PM2 reconcile logic — tách riêng để unit-test (Jest: npm test).

export const pm2Key = (sc, n) => `${sc}::${n}`;

// Giữ lại process vắng mặt tạm thời trong khoảng này trước khi thực sự bỏ khỏi
// UI. Agent có thể bỏ sót process vài nhịp khi PM2 đang chuyển trạng thái.
const GRACE_MS = 15000;

// Hợp nhất danh sách process mới từ agent với trạng thái cũ + các thao tác đang
// chờ (pending). Hai vấn đề của agent khi đang chuyển trạng thái:
//   (a) gửi status CŨ trong các nhịp metrics_pm2 định kỳ;
//   (b) bỏ HẲN process (hoặc nhiều process) khỏi list trong 1–2 nhịp.
// Hàm này: giữ status "kỳ vọng" của thao tác vừa bấm tới khi agent xác nhận, và
// KHÔNG để card biến mất khi process chỉ vắng mặt tạm thời (chờ tới GRACE_MS).
export function reconcileProcs(
  prevProcs,
  incoming,
  serverCode,
  pending,
  now = Date.now()
) {
  // Bỏ entry rác: lúc PM2 đang chuyển trạng thái, agent có thể parse pm2 jlist
  // lỗi và gửi process không có name (name=undefined) → tránh tạo card "lạ".
  incoming = (incoming || []).filter((p) => p && p.name);

  const incByName = new Map(incoming.map((p) => [p.name, p]));
  const prevByName = new Map((prevProcs || []).map((p) => [p.name, p]));

  // Giữ thứ tự cũ trước, sau đó nối process mới xuất hiện
  const order = [];
  const seen = new Set();
  (prevProcs || []).forEach((p) => {
    order.push(p.name);
    seen.add(p.name);
  });
  incoming.forEach((p) => {
    if (!seen.has(p.name)) {
      order.push(p.name);
      seen.add(p.name);
    }
  });

  const out = [];
  for (const name of order) {
    const inc = incByName.get(name);
    const prev = prevByName.get(name);
    const key = pm2Key(serverCode, name);
    const pend = pending[key];
    const active = pend && pend.until >= now;

    if (inc) {
      // Có mặt → bỏ cờ vắng mặt
      const p = { ...inc };
      delete p._missingSince;
      if (active) {
        if (inc.status === pend.expected) delete pending[key]; // agent xác nhận
        else p.status = pend.expected; // còn status cũ → giữ optimistic
      } else if (pend) {
        delete pending[key];
      }
      out.push(p);
      continue;
    }

    // Vắng mặt khỏi list lần này
    if (!prev) continue; // chưa từng tồn tại
    if (active) {
      // Đang có thao tác → giữ card với status kỳ vọng (không tính vắng mặt)
      const p = { ...prev, status: pend.expected };
      delete p._missingSince;
      out.push(p);
      continue;
    }
    const missingSince = prev._missingSince || now;
    if (now - missingSince > GRACE_MS) {
      // Vắng mặt đủ lâu → coi như đã bị xoá thật
      if (pend) delete pending[key];
      continue;
    }
    // Còn trong grace → giữ nguyên process cũ, chờ nhịp sau hiện lại
    out.push({ ...prev, _missingSince: missingSince });
  }
  return out;
}
